import { deleteSelectResource, selectResource } from "@/redux/slices/resources/ResourceSlice";
import { connect } from "react-redux";
import DrawFloorPlan from "./index";

const mapDispatchToProps = {
    selectResource,
    deleteSelectResource
};

export default connect(null, mapDispatchToProps)(DrawFloorPlan);
